import { render } from "./SubclassAddView.vue?vue&type=template&id=6d2c24ee"
import script from "./SubclassAddView.vue?vue&type=script&lang=js"
export * from "./SubclassAddView.vue?vue&type=script&lang=js"

import exportComponent from "/srv/git/index-webapp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__